export default __webpack_public_path__ + "static/media/crew-3.71ede3da.png";